<template>
  <div class="post-bottom-container">
    <div class="tags-container">
      <span
        v-for="tag in tags"
        :key="tag"
        v-tooltip="tag"
        class="tag-label text-truncate"
      > {{ tag }} </span>
    </div>
    <div class="social-metrics-container">
      <PostIconAndTextMetric
        v-for="(metric, index) in metrics"
        :key="index"
        :metric="metric"
        :value="post[metric] || 0"
      />
    </div>
  </div>
</template>

<script>

import PostIconAndTextMetric from '@/components/Post/PostIconAndTextMetric';

export default {
  name: 'PostBottom',
  components: {
    PostIconAndTextMetric,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    isPostWithImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxTags: 3,
      metrics: ['likes', 'shares', 'comments', 'videoplays', 'followers'],
    };
  },
  computed: {
    tags() {
      return Object.assign([], this.post.tags).splice(0, this.maxTags);
    },
  },
};
</script>

<style scoped lang="scss">
  .post-bottom-container {
    padding: 20px;
    display: grid;
    grid-template-rows: 35px 73px;
  }

  .tags-container {
    border-bottom: 1px solid var(--gray-400);
    display: flex;
    justify-content: center;
  }

  .tag-label {
    max-width: 100px;
    border-radius: 100px;
    padding: 2px 5px;
    margin: 0 5px;
    height: 18px;
    line-height: 12px;
    font-size: 12px;
    border: 1px solid var(--gray-300);
  }

  .social-metrics-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    justify-content: center;
    align-items: center;
  }
</style>
